import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllUnidadeMedidaResponse } from '../../responses/produto/get-all-unidade-medida.response';
import { GetUnidadeMedidaResponse } from '../../responses/produto/get-unidade-medida.response';
import { UnidadeMedidaRequest } from '../../requests/produto/unidade-medida.request';
import { ReturnStruct } from '../../structs/return.struct';
import { LookupSelectPesquisavelResponse } from '../../responses/produto/lookup-select-pesquisavel.response';

@Injectable({
    providedIn: 'root',
})
export class UnidadeMedidaService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}unidademedida`;

    /**
     * Obtém a lista de Unidades de Medida.
     */
    public getAll(pesquisa: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllUnidadeMedidaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());
        if (pesquisa) {
            params = params.set('pesquisa', pesquisa);
        }

        return this.httpClient
            .get<GetAllUnidadeMedidaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma unidade de medida por ID.
     */
    public getById(idUnidadeMedida: number): Observable<GetUnidadeMedidaResponse> {
        const url = `${this.apiUrl}/${idUnidadeMedida}`;

        return this.httpClient
            .get<GetUnidadeMedidaResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova unidade de medida.
     */
    public create(request: UnidadeMedidaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma unidade de medida existente.
     */
    public update(idUnidadeMedida: number, request: UnidadeMedidaRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idUnidadeMedida}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma unidade de medida.
     */
    public delete(idUnidadeMedida: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idUnidadeMedida}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas unidades de medida.
     */
    public deleteBulk(idsUnidadeMedida: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsUnidadeMedida }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
   * Endpoint para buscar o lookup de unidades de medida.
   * Corresponde a: [HttpGet] /UnidadeMedida/lookup
   */
    public getLookup(): Observable<LookupSelectPesquisavelResponse> {
        const url = `${this.apiUrl}/lookup`;
        return this.httpClient
            .get<LookupSelectPesquisavelResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
